
import React from 'react';
import { ImageWithFallback } from '@/components/common/ImageWithFallback';
import { Building2 } from 'lucide-react';

interface PlatformLogoProps {
  platformName: string;
  size?: 'sm' | 'md' | 'lg';
}

export const PlatformLogo = ({ platformName, size = 'md' }: PlatformLogoProps) => {
  const getLogo = () => {
    switch(platformName.toLowerCase()) {
      case 'coinstrat pro':
        return 'https://lbvhywxvthwgiebjsrlr.supabase.co/storage/v1/object/public/logoexchangeplatformurl//logo%20coinstrat%20pro.png';
      case 'fxpro':
        return 'https://play-lh.googleusercontent.com/z1qgps1oruxuJnPdEJjK_209y-TI2v0bTQeZf8DxKRz2cR0ULY5-YFzKknA3YzlB7g';
      case 'xm':
        return 'https://play-lh.googleusercontent.com/EPrP4-hkROiDGPmLnMSKaFlfWHCI5HdV1EWXXVnrHezxYK74czgVhPOxn-psu5_T6A';
      case 'ic market':
        return 'https://play-lh.googleusercontent.com/S_LUow-89YSbQdIf0cYK2qWLVOLGCKkRkj9PRlBHzWwE80-znbQZs95TH96cCIbhDA';
      case 'ftmo':
        return 'https://play-lh.googleusercontent.com/Zz9gWxJt7C8wPZ1jd-8O9HMWAkH4KO8OfKvwPinpvZPtYs4RcbC1ckwZQPj4HNB8GQ';
      case 'ai prop':
        return '/lovable-uploads/d8c04af7-018a-4e74-8091-9940d7e03ad7.png';
      default:
        return 'https://play-lh.googleusercontent.com/rZ6p-VXduWWqsOBGpwsyK_ZpNVOYgj8bKlqQGqPbtVwsTAfVk67s3cSLxuXctJBPzZU';
    }
  };

  const sizeClasses = {
    sm: 'h-10 w-10',
    md: 'h-12 w-12',
    lg: 'h-14 w-14'
  };

  return (
    <div className={`${sizeClasses[size]} flex-shrink-0 overflow-hidden rounded-xl border-2 border-primary/20 bg-background p-1.5 shadow-sm`}>
      <ImageWithFallback 
        src={getLogo()} 
        alt={`${platformName} logo`} 
        className="h-full w-full object-contain" 
        showSkeleton={true}
        skeletonClassName="bg-muted/50 rounded-lg"
        priority="high"
        fallbackElement={<Building2 className="h-full w-full text-muted-foreground p-1" />}
      />
    </div>
  );
};
